
import axios from "axios";

export default {
  namespaced: true,
  state: {
      lista: [],
      id: null,
      descricao: null
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    ID: state => {
        return state.id
    },
    DESCRICAO: state => {
        return state.descricao
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_ID: (state, payload) => {
          state.id = payload
      },
      SET_DESCRICAO: (state, payload) => {
          state.descricao = payload
      }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GERAR_LISTA: ({ commit, getters}) => {
        return new Promise((resolve, reject) => {
          let id = (getters.ID !== null ? getters.ID : '')
          let descricao = (getters.DESCRICAO !== null ? getters.DESCRICAO : '')

          let uri = `/api/protected/grupo/acesso/pesquisar?id=${id}&descricao=${descricao}`
          axios
            .get(uri)
            .then(({ data, status }) => {
              commit("SET_LISTA", data);
              if (status === 200 || status === 201) {
                resolve({ data, status });
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      },
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/grupo-acesso-store.js